import React from 'react';
import { prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { useUserSelector } from 'js/store/hooks';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';

import * as hooks from 'js/components/main/MyAccountSidebar/hooks';

import { MyAccountSidebar as CoreMyAccountSidebar } from 'js/components/main/MyAccountSidebar/MyAccountSidebar';

export const MyAccountSidebar = () => {
    const location = useLocation();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const handleSidebarClose = hooks.useHandleSidebarClose();

    useUpdateEffect(() => {
        handleSidebarClose();
    }, [isLoggedIn, location.hash, handleSidebarClose]);

    return <CoreMyAccountSidebar />;
};
